import {
  CREATE_CALCULATOR,
  DELETE_CALCULATOR,
  HIDE_ADD_EDIT_MODAL,
  SET_DATA,
  SHOW_ADD_EDIT_MODAL,
  UPDATE_CALCULATOR,
} from './mutation-types';
import {axiosClient} from '../../../core/services/http.service';

export function setData({commit}, data) {
  commit(SET_DATA, data);
}

export async function getAllCalculator({commit}) {
  const {success, body} = await axiosClient.get('/api/loancalculator');
  if (success) {
    commit(SET_DATA, body);
  }
}

export function showAddEditModal({commit}, calculator = {}) {
  commit(SHOW_ADD_EDIT_MODAL, calculator);
}

export function hideAddEditModal({commit}) {
  commit(HIDE_ADD_EDIT_MODAL);
}

export async function upsertCalculator({commit}, {params, action}) {
  const response = await axiosClient.post('/api/loancalculator/upsert', params);
  if (response.success) {
    if (action === 'create') {
      commit(CREATE_CALCULATOR, response.body);
    } else {
      commit(UPDATE_CALCULATOR, response.body);
    }
  }

  return response;
}

export async function deleteCalculator({commit}, loanCalculatorId) {
  const response = await axiosClient.delete(`/api/loancalculator/delete/${loanCalculatorId}`);
  if (response.success) {
    commit(DELETE_CALCULATOR, loanCalculatorId);
  }

  return response;
}

export async function calculate({commit}, loanCalculatorId) {
  return await axiosClient.post(`/api/loancalculator/calculate/${loanCalculatorId}`);
}